import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/medium-m': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M71.5 142.3C72.1 136.4 69.8 130.5 65.4 126.5L20.3 72.1V64H160.5L268.9 301.7 364.2 64H497.9V72.1L459.3 109.1C456 111.6 454.3 115.8 455 119.9V391.9C454.3 396 456 400.2 459.3 402.7L497 439.7V447.8H307.3V439.7L346.4 401.8C350.2 398 350.2 396.8 350.2 391V171.2L241.5 447.1H226.8L100.4 171.2V356.1C99.3 363.9 101.9 371.7 107.4 377.3L158.2 438.9V447H14.2V439L65 377.3C70.4 371.7 72.9 363.8 71.5 356.1V142.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/medium-m.js
// module id = jSFv
// module chunks = 144